import companiesEdit from './companies-edit';
import companiesNew from './companies-new';
import roles from './roles';
import users from './users';

const route = {
	path: ':codeProject/companies',
	name: 'page-company',
	meta: {
		title: 'Compañías',
	},
	props: true,
	component: () => import('@/pages/companies/page-company'),
	children: [
		companiesEdit,
		companiesNew,
		roles,
		users,
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/companies.js